module.exports = __webpack_public_path__ + "img/logo-gb.21197b3b.png";